import { api, ApiRequestConfig } from './api';
import type { SponsoredProductsDTO, SponsoredProductsParams } from '../types/sponsored-products';

export const getSponsoredProducts = (params: SponsoredProductsParams, config: ApiRequestConfig) =>
  api.get<SponsoredProductsDTO>('sponsored-products', { ...params }, config);
